import styled from 'styled-components'

import { greySecondary } from 'styles/Colors'

export const Container = styled(({ noToolbar, mini, noPadding, height, fontSize, ...props }) => (
  <div {...props} />
))`
  height: ${height => height}px;
  overflow: auto;
  position: relative;
  ${({ mini }) =>
    mini &&
    `
      width: 100%;
      `}
  & > .quill {
    display: flex;
    flex-direction: column;
    height: 100%;
    & > .ql-toolbar {
      ${({ noToolbar }) =>
        noToolbar
          ? 'display: none;'
          : `
      border: none;
      border-bottom: 1px solid ${greySecondary};
      position: sticky;
      top: 0;
      z-index: 10;
      background: #fff;
      `}
    }
    & > .ql-container {
      border: none;
      flex: 1;
      min-height: 0;
      overflow: visible;

      /* Move the link tooltip to stick directly below the toolbar */
      & > .ql-tooltip {
        position: fixed !important;
        top: auto !important;
        left: auto !important;
        right: auto !important;
        bottom: auto !important;
        z-index: 20;
      }

      & > .ql-editor {
        font-size: ${({ fontSize }) => fontSize || 16}px;
        font-family: coresanscr45;
        ${({ mini }) =>
          mini &&
          `
          padding: 12px 4px;
          &:before {
            left: 6px;
            font-style: normal;
          }
        `}
        ${({ noPadding }) => noPadding && `padding: 0;`}
      }
    }
  }
`
